module.exports = __webpack_public_path__ + "img/bg.ca30af77.png";